import React from 'react'

function C2wAppDownloadPopUp( { handleClose } ) {
  return (
    <div className='C2wDownlaodAppPopUp_ctn'>
      <svg onClick={handleClose} className='closeBtn' width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.46318 1.47683C1.77048 1.16963 2.1872 0.997049 2.62172 0.997049C3.05624 0.997049 3.47296 1.16963 3.78026 1.47683L9.99574 7.69231L16.2112 1.47683C16.3624 1.32032 16.5432 1.19548 16.7431 1.1096C16.9431 1.02372 17.1581 0.978515 17.3757 0.976624C17.5932 0.974734 17.809 1.01619 18.0104 1.09859C18.2118 1.18098 18.3948 1.30266 18.5486 1.45652C18.7025 1.61038 18.8242 1.79334 18.9065 1.99473C18.9889 2.19611 19.0304 2.41189 19.0285 2.62947C19.0266 2.84706 18.9814 3.06208 18.8955 3.26201C18.8097 3.46193 18.6848 3.64275 18.5283 3.79391L12.3128 10.0094L18.5283 16.2249C18.8268 16.5339 18.992 16.9479 18.9882 17.3775C18.9845 17.8072 18.8122 18.2182 18.5083 18.522C18.2045 18.8258 17.7935 18.9982 17.3639 19.0019C16.9342 19.0056 16.5203 18.8405 16.2112 18.542L9.99574 12.3265L3.78026 18.542C3.4712 18.8405 3.05727 19.0056 2.62762 19.0019C2.19796 18.9982 1.78696 18.8258 1.48314 18.522C1.17932 18.2182 1.00698 17.8072 1.00325 17.3775C0.999513 16.9479 1.16468 16.5339 1.46318 16.2249L7.67866 10.0094L1.46318 3.79391C1.15598 3.48661 0.983398 3.06989 0.983398 2.63537C0.983398 2.20085 1.15598 1.78413 1.46318 1.47683Z" fill="white"/>
</svg>

      <div className='DowanLoadAppFrom_ctn' >
        <div className='DowanLoadAppFrom_ctn_heading'>
            {'Than you for your response'}
        </div>
        <div className='DowanLoadAppFrom_ctn_heading'>
            <a href='https://play.google.com/store/apps/details?id=com.developer.core2web2&pcampaignid=web_share' target="_blank">
                <span>{'Download'}</span>
            </a>

            &nbsp;{'App From'}
            <a href='https://play.google.com/store/apps/details?id=com.developer.core2web2&pcampaignid=web_share' target="_blank">
                <img src='/assets/images/courseDetails/PlayStoreIcon.png' alt='/' />
            </a>
        </div>
      </div>
    
      {/* <div className='dowanloadPopupButton_div'>
        <button onClick={handleClose}>{"Close"}</button>
      </div> */}
    </div>
  )
}

export default C2wAppDownloadPopUp
